export class SNRestResponse {
    public success: boolean;
    public message: string;
    public valid: boolean;

    private response: any;

    constructor(response: any) {
        this.success = false;
        this.valid = false;
        this.response = response;
        // Check response type and entries to validate
        if (typeof response !== 'undefined') {
            if (typeof response.success === 'boolean') {
                this.success = response.success;
            }
            if (this.success) {
                this.valid = true;
            } else {
                if (typeof response.message !== 'undefined') {
                    this.valid = true;
                    this.message = response.message;
                }
            }
        } else {
            this.valid = false;
        }
    }

    public result(resultName: string): any {
        if (!this.response || typeof this.response[resultName] === 'undefined') {
            return undefined;
        }
        return this.response[resultName];
    }
}
